import React from 'react';
import { Route, Switch } from 'react-router';
import { ConnectedRouter } from 'connected-react-router';
import LoadingBar from './components/loadingBar';

import { history } from './store';
import { SignIn, Callback, PrivateRoute } from './containers/signin';
import ReplenishContainer from './containers/replenish';
import Start from './containers/start';
import MissingPermission from './containers/missingPermission';

import './styles/main.scss';
import Toast from './components/common/toast';
import Calibration from './components/calibration';

const App = () => (
  <React.Fragment>
    <LoadingBar />
    <Toast />
    <ConnectedRouter history={history}>
      <Switch>
        <Route exact path="/signin" component={SignIn} />
        <Route exact path="/callback" component={Callback} />
        <Route exact path="/silent_renew" component={Start} />
        <Route exact path="/" component={Start} />
        <Route exact path="/missing_permission" component={MissingPermission} />
        <Route path="/calibrate" component={Calibration} />
        <PrivateRoute path="/:deviceCode?" component={ReplenishContainer} />
      </Switch>
    </ConnectedRouter>
  </React.Fragment>
);

export default App;
